import * as Sentry from "@sentry/browser";
import { Log } from "../services";
import { getAssetPath } from "@stencil/core";
import ky from "ky";
import { AVBusService } from "./bus.service";
import { HandledError, IBreadcrumb } from "../models/HandledError";
import { ErrorCode } from "../models/enums";

class ErrorHandlerCtrl {
  private breadcrumbs: IBreadcrumb[] = [];
  private maxBreadcrumbs: number = 50; // Limit to prevent memory bloat

  public async init(sentryDsn: string) {
    if (!sentryDsn) {
      return;
    }
    try {
      const data = await Promise.all([
        ky.get(getAssetPath("./auvious-assets/version.json")).json(),
        ky.get(getAssetPath("./auvious-assets/environment.json")).json(),
      ]);
      Sentry.init({
        dsn: sentryDsn,
        release: `com.auvious.genesys-widget-${data[0]["version"]}`,
        allowUrls: ["auvious.video"],
        environment: data[1]["environment"],
        beforeSend(event, hint?) {
          if (
            hint.originalException instanceof Error &&
            !hint.originalException.message
          ) {
            event.fingerprint = ["no-error-message"];
          }

          return event;
        },
      });
    } catch (ex) {
      AVBusService.errorLog(new HandledError(ex, ErrorCode.ERROR_LOG_FAILED));
      Log.error(ex);
    }
  }

  /**
   * Logs error console, sends to BusService and captures Exception in Sentry
   * @param error
   */
  public log(error: HandledError) {
    Log.error(error);
    AVBusService.errorLog(error);

    // now called by AVBusService
    // this.captureError(error);
  }

  public captureError(error: HandledError) {
    Sentry.captureException(error);
  }

  // Add a breadcrumb (e.g., user clicked a button)
  public addBreadcrumb(message: string, metadata?: any): void {
    const breadcrumb: IBreadcrumb = {
      message: message,
      timestamp: new Date(),
      metadata: metadata || {},
    };

    // Maintain the maximum number of breadcrumbs
    if (this.breadcrumbs.length >= this.maxBreadcrumbs) {
      this.breadcrumbs.shift(); // Remove the oldest breadcrumb
    }
    this.breadcrumbs.push(breadcrumb);
  }

  public getBreadcrumbs(): IBreadcrumb[] {
    return this.breadcrumbs;
  }

  public clearBreadcrumbs() {
    this.breadcrumbs = [];
  }

  public captureMessage(message: any[]) {
    Sentry.captureMessage(message.toString());
  }

  public captureEvent(event: Sentry.Event) {
    Sentry.captureEvent(event);
  }
}

export const ErrorHandler = new ErrorHandlerCtrl();
